import { css } from '@emotion/react'
import styled from '@emotion/styled'

const baseStyles = ({ theme }) => css`
  label: content;

  width: 100%;
  flex: 1 auto;
  padding: ${theme.spacings.peta} 0;

  ${theme.media.giga} {
    background-image: url(${window && window.env.assetHost}assets/images/signup/background.svg);
    background-size: 800px;
    background-repeat: no-repeat;
    background-position: calc(100% - 10px) top;
  }
`

export const Content = styled('div')(baseStyles)
